import {
	Component, ViewEncapsulation, OnInit, OnChanges, ChangeDetectorRef,
	Input, Output, EventEmitter, SimpleChanges
} from '@angular/core';
import { ConfirmDialogComponent, language } from 'curvy';
import { Task } from '@task-utils/types';
import { files, find_child_whier, is_under_whier_id, Modal } from '@task-utils/utils';

import { orders_translations } from '../orders.trans';
import { OrderType } from '../orders.types';
import { TaskRoutes } from '@task-utils/routes';
import { User } from '@task-modules/users';
import { Node, WorkHierarchy } from '@task-modules/work-hierarchy';
import { ConfirmDialog } from '@task-components/confirm-dialog.component';



@Component({
	selector: 'task-create-order',
	encapsulation: ViewEncapsulation.None,
	templateUrl: 'create-order.component.html',
	styles: [`
		task-create-order {
			max-width: 600px;
		}

		task-create-order .field-grid {
			display: grid;
			grid-auto-flow: row;
			grid-template-columns: 1fr 1fr;
			grid-gap: 0 8px;
		}

		task-create-order knw-search-picker {
			display: contents;
		}

		task-create-order task-whier-picker label:first-child {
			align-self: start;
		}

		@media only screen and (max-width: 600px) {
			task-create-order .field-grid {
				grid-template-columns: 1fr;
			}
		}
	`]
})
export class CreateOrderComponent implements OnInit, OnChanges {

	order: OrderType;

	priorities = Task.Order_Priority;
	investment_types = Task.Investment_Type;
	edited = false

	order_description = "";
	images: files.IImage[] = [];
	financial_files: (files.IFile | Task.DMSFile)[] = [];
	service_files: (files.IFile | Task.DMSFile)[] = [];
	inventory: Task.KAM_Inventory[] = [];
	cc_emails: string[] = [];

	picked_location: Task.Location = null;
	picked_supplier: Task.Supplier = null;
	whier: Task.Ticket["whier"] = null;
	is_internal_supplier = false;
	picked_worker: Task.User = null;
	order_flags: Task.LabelFlags[] = [];


	@Input()
	tickets: Task.Ticket[] = [];

	@Output('result')
	result: EventEmitter<OrderType> = new EventEmitter();


	constructor(private cdr: ChangeDetectorRef) { }

	ngOnInit() {
		language.load_translations(orders_translations);
		this.order = {
			title: "",
			supplier_id: null,
			location_id: null,
			order_details: [],
			ticket_ids: [],
			investment_type: null,
			cost_estimate: null,
			cc_emails: [],
			whier_id: null,
			iimages: [],
			ifinancial_files: [],
			iservice_files: [],
			preinvoice: false,
			lease: false,
			insurance: false,
			inspection: false,
			complaint: false,
			fng: false,
			arrival_worker: null,
			label_ids: [],
			priority: null
		};

		if (this.tickets && this.tickets.length > 0) {
			this.order.title = this.tickets[0].title;
			this.order.complaint = this.tickets[0].complaint;

			for (let detail of this.tickets[0].ticket_details) {
				if (detail.component_type_id == Task.COMPONENT_TYPE.SERVICE_AND_SUPPORT_DOCUMENT) {
					this.service_files.push({
						ticket_detail_id: detail.ticket_detail_id,
						dms_document_file_name: detail.dms_document_file_name,
						dms_document_id: detail.dms_document_id
					});

				} else if (detail.component_type_id == Task.COMPONENT_TYPE.FINANCIAL_DOCUMENT) {
					this.financial_files.push({
						ticket_detail_id: detail.ticket_detail_id,
						dms_document_file_name: detail.dms_document_file_name,
						dms_document_id: detail.dms_document_id
					})
				}
			}
		}

		if (this.picked_supplier) {
			if (this.picked_supplier.company_type_id === Task.COMPANY_TYPE.INTERNAL_SUPPLIER) {
				this.is_internal_supplier = true;
			}
		}

		this.load_order_flags();
	}

	update_fakturiranje_flag_is_internal() {
		const flag = this.order_flags.find(flag => flag.label_id === 27);

		if (flag && this.picked_location) {
			if (!this.picked_location.internal_tag) {
				flag.selected = true;
			} else {
				flag.selected = false;
			}
		}
	}

	async update_fakturiranje_flag_is_whier() {
		if (!this.picked_location || !this.whier) return;
		const flag = this.order_flags.find(flag => flag.label_id === 27);
		if (!flag) return;

		let root = await WorkHierarchy.get_constructed();
		let whier_node = find_child_whier(root, this.whier.whier_id);

		let whier_for_fakturiranje = is_under_whier_id(whier_node, [6, 7, 8, 9]);

		if (
			(whier_for_fakturiranje && this.picked_location.internal_tag)
			|| (!this.picked_location.internal_tag)
		) {
			flag.selected = true;

		} else {
			flag.selected = false;
		}
	}

	async should_show_fakturiranje_warning() {
		if (!this.picked_location || !this.whier) return false;
		const flag = this.order_flags.find(flag => flag.label_id === 27);
		if (!flag) return false;
		if (flag.selected) return false;
		if (!this.picked_location.internal_tag) return false;

		let root = await WorkHierarchy.get_constructed();
		let whier_node = find_child_whier(root, this.whier.whier_id);
		let whier_for_fakturiranje = is_under_whier_id(whier_node, [6, 7, 8, 9]);
		return whier_for_fakturiranje;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.tickets.length > 0) {
			let text = "";
			let inventory: Task.KAM_Inventory[] = [];
			let images: Promise<files.IImage>[] = [];
			let whier: Task.Ticket["whier"] = null;

			for (let ticket of this.tickets) {
				whier = ticket.whier;

				for (let detail of ticket.ticket_details) {
					switch (detail.component_type_id) {
						case Task.COMPONENT_TYPE.TEXT:
							text += detail.answer + "\n";
							break;

						case Task.COMPONENT_TYPE.OPTION:
							text += detail.question + ': ' + detail.answer + "\n";
							break;

						case Task.COMPONENT_TYPE.TOGGLE:
							if (detail.answer) {
								text += detail.question + "\n";
							}
							break;

						case Task.COMPONENT_TYPE.IMAGE:
							images.push(files.url_to_iimage(detail.answer));
							break;

						case Task.COMPONENT_TYPE.INVENTORY:
							inventory.push({
								...detail.inventory_data,
								inventory_id: detail.inventory_id,
								inventory_name: detail.inventory_name,
								inventory_no: detail.inventory_no,
								inventory_serial_no: detail.inventory_serial_no,
							});
							break;

					}
				}
			}

			if (this.picked_location == null) {
				let location_id = this.tickets[0].location_id;
				if (location_id != null && location_id != undefined) {
					TaskRoutes.locations.api_location_get_single(location_id).then(res => {
						this.picked_location = res.data;
						this.order_description = text;
						this.inventory = inventory;
						this.whier = whier;

						return Promise.all(images);
					}).then(imgs => {
						this.images = imgs;
					});
				}
			}
		}
	}


	async load_order_flags() {
		const res = await TaskRoutes.label_flags.api_label_flags_get_all(User.currentUser.company_id);

		let ticket_label_ids: number[] = [];
		if (this.tickets && this.tickets.length > 0 && this.tickets[0].labels) {
			ticket_label_ids = this.tickets[0].labels.map(label => label.label_id);
		}

		for (const flag of res.data) {
			if (flag.status_id === Task.LABEL_FLAG_STATUS.DELETED) {
				continue;
			}

			const should_show = flag.orders;

			if (!should_show) {
				continue;
			}

			const was_selected_on_ticket = ticket_label_ids.includes(flag.label_id);

			this.order_flags.push({
				...flag,
				selected: was_selected_on_ticket
			});

			if (was_selected_on_ticket) {
				this.order.label_ids.push(flag.label_id);
			}
		}

		this.update_fakturiranje_flag_is_internal();
		this.update_fakturiranje_flag_is_whier();
	}

	on_label_flag_change(flag: Task.LabelFlags) {
		if (flag.selected) {
			if (!this.order.label_ids.includes(flag.label_id)) {
				this.order.label_ids.push(flag.label_id);
			}
		} else {
			const index = this.order.label_ids.indexOf(flag.label_id);
			if (index > -1) {
				this.order.label_ids.splice(index, 1);
			}
		}
	}

	search_suppliers = async (search: string) => {
		let res = await TaskRoutes.suppliers.api_supplier_search(
			{ attributes: ["company.name"], search: [search] },
			{ page_no: 1, page_size: 15 }
		);

		return res.data;
	}

	format_supplier_name(supp: Task.Supplier) {
		if (!supp) { return ""; }
		return supp.name;
	}

	search_workers = async (search: string) => {
		let res = await TaskRoutes.users.api_user_search({
			search: [search, `${Task.USER_TYPE.COMPANY_WORKER}`],
			attributes: ['first_name+ +last_name', "#=:user_type_id"]
		}, {
			page_no: 1,
			page_size: 100
		})

		return res.data.sort((a, b) => {
			return a.last_name.localeCompare(b.last_name)
		})

	}

	format_worker_name(usr: Task.User) {
		if (!usr) return "";
		return `${usr.first_name} ${usr.last_name}`
	}

	picked_supplier_handler(ev: Task.Supplier) {
		if (ev.company_type_id === 1) {
			this.is_internal_supplier = true;
		} else {
			this.is_internal_supplier = false;
		}
	}


	add_cc_email() {
		this.cc_emails.push('');
	}

	remove_cc_mail(index: number) {
		this.cc_emails.splice(index, 1)
	}

	async done() {

		if (await this.should_show_fakturiranje_warning()) {
			let res = await Modal.open(ConfirmDialogComponent, {
				title: language.translate("CONFIRMATION"),
				message: language.translate("ORDER.SAVE_WARNING_WITHOUT_PREINVOICE")
			});

			let ok = "data" in res && res.data;
			if (!ok) return;
		}

		if (this.picked_location) {
			this.order.location_id = this.picked_location.location_id;
		}

		this.order.arrival_worker = this.picked_worker || null;


		this.order.order_details = [];
		this.order.order_details.push({
			order_detail_type_id: Task.ORDER_DETAIL_TYPE.DESCRIPTION,
			description: this.order_description
		});

		// @HACK(borna): Why is cost_estimate a string?
		this.order.cost_estimate = parseFloat(this.order.cost_estimate) as any;
		if (this.order.cost_estimate !== this.order.cost_estimate) {
			this.order.cost_estimate = null;
		}

		this.order.supplier_id = this.picked_supplier.supplier_id;
		this.order.whier_id = this.whier.whier_id;
		this.order.iimages = this.images;
		this.order.ifinancial_files = this.financial_files;
		this.order.iservice_files = this.service_files;
		this.order.cc_emails = this.cc_emails;

		this.order.label_ids = this.order_flags.filter(f => f.selected).map(f => f.label_id);

		for (let inv of this.inventory) {
			this.order.order_details.push({
				order_detail_type_id: Task.ORDER_DETAIL_TYPE.INVENTORY,
				description: "-", // Description is mandatory with order details
				inventory_id: inv.inventory_id,
				inventory_name: inv.inventory_name,
				inventory_no: inv.inventory_no,
				inventory_serial_no: inv.inventory_serial_no,
				inventory_data: inv
			});
		}

		this.result.emit(this.order);
	}

	cancel() {
		this.result.emit(null);
	}
}
